document.addEventListener("DOMContentLoaded", function() {
  // Buscamos todos los elementos con nuestra clase personalizada
  const contenedores = document.querySelectorAll('.fuerza-horizontal');
  
  contenedores.forEach(function(contenedor) {
    // 1. Limpiamos cualquier estilo inline que el tema le meta por JS o Liquid
    contenedor.removeAttribute('style');
    
    // 2. Rastreamos sus hijos directos (las dos columnas)
    const columnas = contenedor.children;
    
    // A cada columna le removemos sus estilos inline heredados y le metemos una subclase limpia
    for (let i = 0; i < columnas.length; i++) {
      columnas[i].removeAttribute('style');
      columnas[i].classList.add('columna-limpia');
      
      // Rastreamos los elementos internos (títulos, links, botones) para limpiar basura inline
      const elementosInternos = columnas[i].querySelectorAll('*');
      elementosInternos.forEach(function(el) {
         // Si es el botón blanco, le ponemos una clase identificadora limpia
         if (el.tagName === 'BUTTON' || el.classList.contains('button')) {
           
           el.classList.add('boton-limpio');
         }
      });
    }
  });
});